/**
 * Route for `multi-currency`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MultiCurrencyPage } from "../features/multi-currency/MultiCurrencyPage";

export const multiCurrencyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/multi-currency",
	component: MultiCurrencyPage,
});

export default multiCurrencyRoute;
